import {
    AlertTypes,
    GenericFormContainer,
    IAlertData,
    Leap4Breadcrumbs,
    Mode,
    Spinner,
    apiClient,
    Toc,
    Groups,
} from "@leap4/frontend";
import {EditAdvertiserLoginsStore} from "./EditAdvertiserLoginsStore";
import {useParams} from "react-router-dom";
import {useEffect, useMemo, useState} from "react";
import {AdvertiserLoginsBaseUrl} from "../../../../config/generals";
import {RootState} from "../../../../store/store";
import {connect, ConnectedProps, useDispatch} from "react-redux";
import {urlService} from "../../../routing/urlsService";
import {DetailsForm} from "../DetailsForm";
import {AdvertiserLoginContext} from "../AdvertiserLoginContext";
import {IAdvertiserLogins} from "../../interfaces/IAdvertiserLogins";
import {initialAdvertiserLoginObj} from "../AdvertiserLogin";
import {setAlert} from "../../../../actions/alert";
import {updateAdvertiserLoginPartners} from "../../../../actions/users";

const mapStateToProps = (state: RootState) => ({});

const mapActions = {
    setAlert
}

export interface IEditGroupProps extends PropsFromRedux {
    setGroup: (data: IAlertData) => void;
    setAlert: any;
}

const connector = connect(mapStateToProps, mapActions);
type PropsFromRedux = ConnectedProps<typeof connector>;

let editAdvertiserLoginsStore: EditAdvertiserLoginsStore


const _editAdvertiserLogins = (props: IEditGroupProps) => {
    const {setGroup, setAlert} = props
    const dispatch = useDispatch();
    const params = useParams<{ id?: string }>();
    const [advertiserLogin, setAdvertiserLogin] = useState<IAdvertiserLogins>(initialAdvertiserLoginObj);
    const ALContextValue = useMemo(() => ({advertiserLogin, setAdvertiserLogin}), [advertiserLogin]);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)

    const onSubmit = async () => {
        if (isLoading) return;
        if (!advertiserLogin.demandPartners?.length) {
            setAlert("No partners picked", AlertTypes.FAILURE)
            return;
        }
        setIsLoading(true)
        await updateAdvertiserLoginPartners(dispatch, {
            organizationId: advertiserLogin.organizationId,
            advertiserLoginId: advertiserLogin.advertiserLoginId,
            partners: advertiserLogin.demandPartners,
        })
        setAlert("Updated", AlertTypes.SUCCESS)
        setIsLoading(false)
    };

    const fetchData = async (id: string) => {
        editAdvertiserLoginsStore = await new EditAdvertiserLoginsStore({
                setIsLoading,
                setIsLoadError,
                setItem: setAdvertiserLogin,
                axiosClient: apiClient,
                alertFunc: setGroup,
                baseUrl: `${AdvertiserLoginsBaseUrl}`
            }
        )
        return await editAdvertiserLoginsStore.refreshItem(id);
    }

    useEffect(() => {
        if (!params.id) {
            return;
        }
        (async () => {
            try {
                setIsLoading(true);
                await fetchData(params.id)
            } catch (e) {
                setAlert("Error connecting to database", AlertTypes.FAILURE)
            } finally {
                setIsLoading(false);
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id])

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }
    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: "Advertiser logins Dashboard",
                link: urlService.advertiserLogins(),
                icon: <Groups/>
            }, {
                text: advertiserLogin?.publisherName,
                link: urlService.organizations() + "/" + advertiserLogin?.organizationId,
                icon: <Toc/>
            }, {
                text: advertiserLogin?.advertiserName,
                link: urlService.organizations() + "/" + advertiserLogin?.advertiserLoginId,
                icon: <Toc/>
            },
            ]}
            />
            <GenericFormContainer mode={Mode.Edit} onCreateOrEditFunc={onSubmit} buttonsProps={{delete: {"disabled": true}}}>
                <AdvertiserLoginContext.Provider value={ALContextValue}>
                    <DetailsForm mode={"edit"}/>
                </AdvertiserLoginContext.Provider>
            </GenericFormContainer>
        </>
    )
}

export const editAdvertiserLogins = connect(mapStateToProps, {
    setAlert
})(_editAdvertiserLogins);
